<template>

  <section id="symbolData">
    <big-loader v-if="!symbolInfo"/>

    <div id="main">
      <div>
        <div id="symbolInfo" v-if="symbolInfo" ref="symbolTopInfo">
          <div id="logo" :class="{noLogo: hideLogo}">
            <img :src="logo" ref="logo" v-if="!hideLogo"/>
            <span id="ticker" v-if="hideLogo">{{ symbol }}</span>
          </div>


          <div>
            <div class="symbolHeader">
              <h2>{{ symbolInfo.symbolInfo.exchange }}:{{ symbolInfo.symbolInfo.symbol }}</h2>

            </div>

            <div id="addRemoveContainer">
              <h3>{{ symbolInfo.symbolInfo.name }}</h3>
         
            </div>

            <h3 class="sectorDescription">

              <span @click="openFloatingSymbolsList(`/symbols/filter?industry=${encodeURIComponent(symbolInfo.symbolInfo.industry)}`, symbolInfo.symbolInfo.industry)" class="linkable">{{ symbolInfo.symbolInfo.industry }} <i class="ri-external-link-line"></i></span> &bull;
              <span @click="openFloatingSymbolsList(`/symbols/filter?sector=${encodeURIComponent(symbolInfo.symbolInfo.sector)}`, symbolInfo.symbolInfo.sector)" class="linkable">{{ symbolInfo.symbolInfo.sector }} <i class="ri-external-link-line"></i></span>
            </h3>

                 <div class="hideMobile" style="margin-top: 1rem;">
                <div class="addRemoveSymbol add" @click="addRemoveWatchlistSymbol(symbol)"
                     v-if="!watchlist || !watchlist.watchlist.includes(symbol)">
                  {{ dictionary.buttons.addToPortfolio }}
                </div>
                <div class="addRemoveSymbol remove" @click="addRemoveWatchlistSymbol(symbol)"
                     v-if="watchlist && watchlist.watchlist.includes(symbol)">
                  {{ dictionary.buttons.removeFromPortfolio }}
                </div>
              </div>
          </div>

              <p id="symbolPriceRow" class="hideMobile" v-if="symbolInfo?.prices">
          <SymbolLabel
              :symbol="{symbol: symbol, price: symbolInfo.prices.price, changeP: symbolInfo.prices.changeP}"
              :prices="{price: {price: symbolInfo.prices.price, changeP: symbolInfo.prices.changeP}}"
              :pre-market-quote="symbolInfo.prices.preMarket"
              :post-market-quote="symbolInfo.prices.postMarket"
              :show-pre-post="true"
              :huge="true"
              :dont-link="true" :always-on="true" :price-only="true"/>
        </p>

        </div>

                      <p id="symbolPriceRow" class="showMobile" v-if="symbolInfo?.prices">
          <SymbolLabel
              :symbol="{symbol: symbol, price: symbolInfo.prices.price, changeP: symbolInfo.prices.changeP}"
              :prices="{price: {price: symbolInfo.prices.price, changeP: symbolInfo.prices.changeP}}"
              :pre-market-quote="symbolInfo.prices.preMarket"
              :post-market-quote="symbolInfo.prices.postMarket"
              :show-pre-post="true"
              :huge="true"
              :dont-link="true" :always-on="true" :price-only="true"/>
        </p>

        <div class="showMobile mobileAddRemove">
          <div class="addRemoveSymbol add" @click="addRemoveWatchlistSymbol(symbol)"
               v-if="!watchlist || !watchlist.watchlist.includes(symbol)">
            {{ dictionary.buttons.addToPortfolio }}
          </div>
          <div class="addRemoveSymbol remove" @click="addRemoveWatchlistSymbol(symbol)"
               v-if="watchlist && watchlist.watchlist.includes(symbol)">
            {{ dictionary.buttons.removeFromPortfolio }}
          </div>
        </div>

    
        <div style="height: 1rem;"></div>

        <div v-if="symbolInfo?.events">
          <SymbolTagLabel v-if="symbolInfo.events?.earnings" :data="symbolInfo.events.earnings" :full="true" :type="'E'"/>
          <SymbolTagLabel v-if="symbolInfo.events?.dividends" :data="symbolInfo.events.dividends" :full="true" :type="'D'"/>
          <SymbolTagLabel v-if="symbolInfo.events?.split" :data="symbolInfo.events.split" :full="true" :type="'S'"/>
        </div>

      </div>

      <div class="seeFull" v-if="isPreview" @click="closePreview()">
        <router-link :to="`/symbol/${symbol}`"/>
        {{ dictionary.buttons.seeFullDetails }}
      </div>

      <div class="eventsBlock">
        <div class="eventData priceBlock" v-if="symbolInfo?.symbolInfo?.nextDividendExDate">



          <div class="priceBlockTitle" style="font-size: 18px"><b><i class="ri-calendar-line"/> {{ symbolPageLabels.nextDividend }}:</b>
            ${{ symbolInfo.symbolInfo.nextDividendExDate.amount }}
          </div>
          <div><b>{{ symbolPageLabels.exDate }}:</b> {{ symbolInfo.symbolInfo.nextDividendExDate.exDate }}
            (<small>{{ dictionary.messages.exDiv }}</small>)
          </div>
          <div><b>{{ symbolPageLabels.paymentDate }}:</b> {{ symbolInfo.symbolInfo.nextDividendExDate.paymentDate }}
          </div>


        </div>

        <div class="eventData priceBlock" v-if="symbolInfo?.symbolInfo?.nextEarningsReport?.releaseTime">
          <div class="priceBlockTitle" style="font-size: 18px"><b><i class="ri-calendar-line"/> {{ symbolPageLabels.nextEarnings }}:</b>

            {{ symbolInfo.symbolInfo.nextEarningsReport.date }}
          </div>
          <div><b>{{ symbolPageLabels.releaseTime }}:</b>
            {{ formatReleaseTime(symbolInfo.symbolInfo.nextEarningsReport.releaseTime) }}
          </div>
          <div><b>{{ symbolPageLabels.estimatedEps }}:</b> <span :dir="uiDirection" class="rtlBidi">{{
              formatEpsEstimate(symbolInfo.symbolInfo.nextEarningsReport.epsEstimate)
            }}</span></div>
        </div>

        <div class="eventData priceBlock" v-if="symbolInfo?.symbolInfo?.nextSplitDate">
          <div class="priceBlockTitle" style="font-size: 18px"><b><i class="ri-calendar-line"/> {{ symbolPageLabels.nextSplitDate }}:</b>
            {{ symbolInfo.symbolInfo.nextSplitDate.date }}
          </div>
          <div><b>{{ symbolPageLabels.splitRatio }}:</b> {{ symbolInfo?.symbolInfo?.nextSplitDate.ratio }}</div>
        </div>


      </div>

      <div id="prices" v-if="symbolInfo && equityPrice">
        <div class="priceRow">
          <SymbolPagePriceBlock :title="symbolPageLabels.pe" :price="equityPrice.pe"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.eps" :tooltip="dictionary.symbolPage.epsNote"
                                :price="equityPrice.eps"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.marketCap"
                                :price="formatNumber(equityPrice.marketCap, '$0,0.00a')"/>
        </div>

        <div class="priceRow" v-if="symbolInfo?.prices">


          <SymbolPagePriceBlock :title="symbolPageLabels.volume"
                                :price="formatNumber(equityPrice.volume, '0,0')" :secondTitle="symbolPageLabels.relVol" :secondValue="symbolInfo?.prices?.relVol"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.avgVolume"
                                :price="formatNumber(equityPrice.avgVolume, '0,0')"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.sharesOutstanding"
                                :price="formatNumber(equityPrice.sharesOutstanding, '0,0')"/>
        </div>

        <div class="priceRow" v-if="symbolInfo?.prices">
          <SymbolPagePriceBlock :title="symbolPageLabels.dailyRange"
                                :price="formatNumber(valueExists(equityPrice.dayLow, equityPrice.dayHigh), '0,0.00')"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.fiftyTwoWeeks"
                                :price="formatNumber(valueExists(equityPrice.yearLow, equityPrice.yearHigh), '0,0.00')"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.previousClose" :price="symbolInfo.prices?.previousClose"/>
        </div>


        <div class="priceRow" v-if="symbolInfo?.prices">
          <SymbolPagePriceBlock :title="symbolPageLabels.rsi" :price="valueExists(symbolInfo.prices?.rsi?.value)"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.macd" :price="valueExists(symbolInfo.prices?.macd.histogram)"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.obvTrend" :price="valueExists(symbolInfo.prices?.obvTrend)"/>
          <SymbolPagePriceBlock :title="symbolPageLabels.atrTrend" :price="valueExists(symbolInfo.prices?.atr?.atrTrend)" :secondTitle="symbolPageLabels.atrPercent" :secondValue="valueExists(symbolInfo.prices?.atr.atrPercent)"/>
        </div>


        <div class="aboutTheCompany"
             v-if="symbolInfo.symbolInfo?.description && symbolInfo.symbolInfo.description.trim().length > 0">
          <h3>{{ dictionary.symbolPage.about }}</h3>
          <p class="description" :dir="uiDirection">{{ companyDescription }} <span
              class="button label inline small bold" @click="showFullDescription = !showFullDescription;">
            {{ showFullDescription ? dictionary.buttons.readLess : dictionary.buttons.readMore }}
          </span></p>
        </div>

        <peers-partial :symbol="symbol" :peers="peers" :isPreview="isPreview" :symbol-page-labels="symbolPageLabels"
                       :isDev="isDev"/>

        <div style="margin: 2rem 0">
          <h3>{{ dictionary.symbolPage.performanceOverTime }}</h3>
          <PriceChange :price-change="symbolInfo.priceChange"/>
        </div>
      </div>
    </div>


  </section>
</template>

<script>
import SymbolPagePriceBlock from "../../components/symbols/symbolPagePriceBlock";
import BigLoader from "../../components/ui/BigLoader";
import numeral from "numeral";
import {useNewYorkTime} from "../../stores/newYorkTime";
import {getCurrentInstance, onMounted} from "vue";
import extraEventData from "../../composables/eventTagExtraData";
import SymbolService from "../../services/symbols";
import SymbolLabel from "../../components/symbols/symbol";

import intersectionObserver from '../../composables/intersectionObserver';
import UserService from "../../services/user";
import PriceChange from "./PriceChange";
import ChartNote from "../../components/charts/ChartNote";
import SymbolLogo from "../../components/symbols/symbolLogo";
import PeersPartial from "./PeersPartial";
import eventBus from "../../services/events";
import SymbolTagLabel from "../../components/symbols/symbolTagLabel";

const {observer} = intersectionObserver();

export default {
  name: "OverviewPartial",
  components: {
    PeersPartial,
    SymbolLogo, ChartNote, PriceChange, SymbolLabel, BigLoader, SymbolPagePriceBlock, SymbolTagLabel
  },
  props: ['symbol', 'isPreview', 'equityPrice', 'watchlist', 'peers', 'isDev'],
  data() {
    return {
      logo: null,
      isLoadingPeers: false,
      wasPeersLoaded: true,
      refreshPageDataInterval: null,
      showFullDescription: false,
      hideLogo: false,
      symbolInfo: null,
      observer: null,
      symbolPageLabels: this.dictionary.symbolPage,
    }
  },
  setup() {

    const nyTime = useNewYorkTime();
    const app = getCurrentInstance();

    function startDataRefresh() {

      if (!app.ctx.refreshPageDataInterval) {

        app.ctx.refreshPageDataInterval = setInterval(() => {
          app.ctx.getSymbolDetails();
        }, 60000);
      }
    }

    onMounted(() => {

      setTimeout(() => {
        if (nyTime.isMarketOpen) {

          if (app.refs.chart) {
            startDataRefresh();
          } else {
            setTimeout(() => {

              startDataRefresh();
            }, 5000);
          }
        }
      }, 10000);
    });

    const defaultPeriod = nyTime.isMarketOpen ? '1d' : '1m'
    return {extraEventData, nyTime, defaultPeriod}
  },
  methods: {
    openFloatingSymbolsList (endpoint, title) {

      eventBus.emit('floatingSymbolsList', {endpoint, title})
    },
    formatReleaseTime(releaseTime) {


      if (!releaseTime) return '-';
      return this.dictionary.calendars.labels[releaseTime === 'bmo' ? 'preMarket' : 'afterMarket']
    },
    formatEpsEstimate(eps) {

      if (!eps) return '-';
      return '$' + eps
    },
    closePreview() {
      eventBus.emit('showChangeableContent', null);
    },
    findInterestingStocks() {
      this.isLoadingPeers = true;
      setTimeout(() => {

        this.isLoadingPeers = false;
        this.wasPeersLoaded = true;
      }, Math.random() * (4000 - 2000) + 2000);
    },
    setLogoBg(symbol) {

      return {backgroundImage: `url(https://financialmodelingprep.com/image-stock/${symbol}.png)`}
    },
    async getSymbolDetails() {

      this.symbolInfo = await SymbolService.getSymbolInfo(this.symbol);
      this.$nextTick(() => {
        if (this.$refs.symbolTopInfo) {
          this.observer.observe(this.$refs.symbolTopInfo);
        }
      });
    },
    async addRemoveWatchlistSymbol(symbol) {

      if (this.watchlist.watchlist.includes(symbol)) {

        try {
          mixpanel.track('symbol:remove', {client: window.location.host, symbol: symbol});
        } catch (e) {
        }

        const watchlist = await UserService.removeSymbolFromWatchlist(symbol)
        this.watchlist.updateWatchlist(watchlist);
      } else {

        try {
          mixpanel.track('symbol:add', {client: window.location.host, symbol: symbol});
        } catch (e) {
        }
        const watchlist = await UserService.addSymbolToWatchlist(symbol)
        this.watchlist.updateWatchlist(watchlist);
      }
    },
    setLogo() {
      let loadImage = new Image();
      loadImage.crossOrigin = 'anonymous'
      loadImage.style.width = '100%';

      loadImage.onload = () => {
        this.logo = `https://financialmodelingprep.com/image-stock/${this.symbol}.png`
        setTimeout(() => {
        }, 1);
      };

      loadImage.onerror = () => {
        this.hideLogo = true;
      }

      loadImage.src = `https://financialmodelingprep.com/image-stock/${this.symbol}.png`;
    },
    formatNumber(value, format) {
      if (value === null || value === undefined) return '-';
      if (value.toString().includes(' - ')) {

        let splitRange = value.split(' - ').map(valuePart => numeral(valuePart).format(format))
        return splitRange.join(' - ')
      }
      return numeral(value).format(format).toUpperCase()
    },
    valueExists() {
      const args = [...arguments];
      if (args.some(argument => argument === null || argument === undefined)) {

        return '-'
      } else {
        return args.join(' - ')
      }
    },
    observerCallback(entries, observer) {

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$emit('scrolledUp')
        } else {
          this.$emit('scrolledDown')

        }
      });

      this.$emit('feedLoaded');
    },
  },
  computed: {
    companyDescription() {

      if (!this.symbolInfo?.symbolInfo?.description) return '';
      return !this.showFullDescription ? this.symbolInfo.symbolInfo.description.split(/[ ]/g).splice(0, 50).join(' ') + '...' : this.symbolInfo.symbolInfo.description;
    }
  },
  async mounted() {


    let observerOptions = {
      rootMargin: '0px',
      threshold: 0
    }
    this.observer = new IntersectionObserver(this.observerCallback, observerOptions);
    this.getSymbolDetails();
    this.setLogo();
  },
}
</script>

<style scoped lang="scss">

@import "../../assets/style/general";
@import "../../assets/style/vars";
@import "../../assets/style/notification";
@import "../../assets/style/controls";

#main {
  padding: $minSpacing;
  box-sizing: border-box;
  width: 100%;
}


.priceRow {
  display: flex;
  gap: $minSpacing;
  margin-bottom: $minSpacing;

  &:last-of-type {
    margin-bottom: 0;
  }
}

#symbolHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--notficationBorderColor);
  @media(max-width: 660px) {
    flex-direction: column;
  }
}

#addRemoveContainer {
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 2rem;
}

#symbolInfo {
  display: flex;
  align-items: center;
  gap: 1rem;

  #symbolPriceRow {
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 0 auto;

    .symbolsTag {
     @media(max-width: 768px) {
       justify-content: center;
       width: 100%;
     }
    }
  }

  #ticker {
    font-weight: bold;
  }

  #logo {
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.2);
    padding: 12px;
    box-sizing: border-box;
    width: 94px;
    height: 94px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
    }
  }

  h2 {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 700;
    font-size: 36px;
  }

  h3 {
    opacity: .8;
    margin: -3px 0 0 0;
    font-size: 22px;
    font-weight: 600;
    line-height: 22px;
    padding: 0;
    @media(max-width: 768px) {
      font-size: 18px;
    }
  }

  .sectorDescription {
    margin-top: 5px; font-size: 18px;
    span {
      cursor: pointer;
    }
    @media(max-width: 768px) {
      margin-top: 0;
      font-size: 14px;
    }
  }

  p {
    margin: $smallGap 0;
  }
}

.noLogo {
  background: var(--highlightColorOpacity) !important;
  color: var(--highlightColor) !important;
}

.brightLogo {
  background: #1a1a1a !important;
}

#symbolPage[dir="rtl"] {
  #symbolInfo {
    h2, h3 {
      direction: rtl;
      text-align: right;
    }
  }
}

.symbolHeader {
  display: flex;
  gap: 1rem;
  align-items: center;
}


.addRemoveSymbol {
  font-size: 17px;
  padding: 8px 18px;
}

.notificationTags {
  margin: -25px 0 25px;
  justify-content: center;

  .tag {
    display: flex;
    align-items: center;
    gap: 5px;
    margin: unset;
  }
}

.eventsBlock {
  margin-bottom: 1rem;
  display: flex;
  gap: 1rem;
  @media (max-width: 660px) {
    flex-direction: column;
  }
}

.eventData {
  background: linear-gradient(200deg, rgba(0, 0, 0, 0) 0%, var(--opacityPurple) 300%);

  color: var(--textColor);
  box-sizing: border-box;
}

.eventInfo {
  position: relative;
  background: var(--lightYellow);
  border-radius: 50%;
  width: 15px;
  color: black;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
}

.tooltipExplanation {
  position: absolute;
  width: 190px;
  z-index: 3;
  background: var(--bgColor);
  left: 50%;
  transform: translateX(-50%);
  top: 30px;
  font-size: 14px;
  padding: 5px;
  border-radius: 8px;
  box-shadow: 0 5px 25px 0 rgba(15, 15, 15, .15);

  .ri-close-line {
    background: black;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    font-size: 16px;
  }
}

.aboutTheCompany {

  h3 {
    margin-bottom: 1rem;
    padding: 0;
  }

  .description {
    line-height: 24px;
  }

  .description[dir="rtl"] {
    direction: rtl;
    text-align: right;
  }
}


.seeFull {
  background: var(--lightYellow);
  color: var(--bgColor);
  border-radius: 8px;
  padding: 5px;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 1rem;
  position: relative;

  a {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

.mobileAddRemove {
  div {
  box-sizing: border-box;
    width: 100%;
    margin-top: .5rem;
    padding: .5rem;
  }
}

.linkable {
  color: var(--highlightColor);
  cursor: pointer;
  border-bottom: 2px dotted var(--highlightColor);
}
</style>
